<template>
    <div class="validation-messages" v-if="show || data.$model !== ''">
        <div class="invalid-feedback v-required" v-if="data.$params.required && !data.required && data.length > 0">
            Required
        </div>
        <div v-if="data.$params.minLength && data.$params.maxLength && data.$params.minLength.min === data.$params.maxLength.max">
            <div class="invalid-feedback" v-if="!data.minLength || !data.maxLength">
                Feltet skal være {{ data.$params.minLength.min }} karakterer
            </div>
        </div>
        <div v-else>
            <div class="invalid-feedback v-minlength" v-if="show || data.$params.minLength && !data.minLength">
                Feltet skal være min. {{ data.$params.minLength.min }} karakterer
            </div>
            <div class="invalid-feedback v-maxlength" v-if="data.$params.maxLength && !data.maxLength">
                Feltet må max være {{ data.$params.maxLength.max }} karakterer
            </div>
        </div>
        <div class="invalid-feedback v-numeric" v-if="data.$params.numeric && !data.numeric">
            Feltet må kun indeholde tal
        </div>
        <div class="invalid-feedback v-alpha" v-if="data.$params.alpha && !data.alpha">
            Feltet må kun indeholde bogstaver og tegn
        </div>
        <div class="invalid-feedback v-alphanum" v-if="data.$params.alphaNum && !data.alphaNum">
            Feltet må kun indeholde bogstaver, tegn og tal
        </div>
        <div class="invalid-feedback v-email" v-if="data.$params.email && !data.email">
            Ugyldigt e-mail format
        </div>
    </div>
</template>

<style lang="scss" scoped>
.validation-messages {

    .invalid-feedback {
        display: block;
    }
}
</style>

<script>
export default {
    props: ['data', 'show']
}
</script>



// WEBPACK FOOTER //
// validationMessages.vue?23f9a1ea